var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#616161;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,17.1c-0.2-0.4-0.5-0.8-0.8-1.4l0,0l-0.8-1.3l0-0.1c-0.7-1.2-1.2-2.6-1.4-4l0-0.1l-0.3-3 C19.8,3.1,16.3,0,12,0v0h0c0,0,0,0,0,0c0,0,0,0,0,0h0v0C7.7,0,4.2,3.1,3.7,7.2l-0.3,3l0,0.1c-0.2,1.4-0.6,2.8-1.4,4l0,0.1l-0.8,1.3 l0,0c-0.3,0.6-0.6,1-0.8,1.4c-0.2,0.4-0.3,0.8-0.3,1.2c0.1,0.5,0.3,0.9,0.7,1.2C1.1,19.8,1.5,19.9,2,20c0.4,0,1,0,1.7,0h0h3.7 c0,0,0,0,0,0c0.3,1.1,0.9,2.1,1.7,2.8C9.9,23.6,10.9,24,12,24v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0 c1,0,2.1-0.4,2.9-1.1c0.8-0.7,1.4-1.7,1.7-2.8c0,0,0,0,0,0h3.7h0c0.7,0,1.2,0,1.7,0c0.4,0,0.9-0.1,1.2-0.4c0.4-0.3,0.6-0.7,0.7-1.2 C24.1,17.9,23.9,17.5,23.7,17.1z M14,21.9c-0.6,0.5-1.3,0.8-2,0.8c-0.7,0-1.4-0.3-2-0.8c-0.5-0.5-1-1.1-1.2-1.9H12H12h3.2 C15,20.8,14.6,21.4,14,21.9z M22.6,18.1c0,0.2-0.1,0.3-0.2,0.4c0,0-0.1,0.1-0.5,0.1c-0.4,0-0.8,0-1.6,0H12H12H3.7 c-0.7,0-1.2,0-1.6,0c-0.4,0-0.5-0.1-0.5-0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0,0,0-0.2,0.1-0.5c0.2-0.3,0.4-0.7,0.8-1.3l0.8-1.3l0-0.1 c0.8-1.4,1.4-2.9,1.6-4.5l0-0.1l0.3-3c0.4-3.4,3.4-6,6.9-6c3.6,0,6.5,2.6,6.9,6l0.3,3l0,0.1c0.2,1.6,0.7,3.1,1.6,4.5l0,0.1l0.8,1.3 c0.4,0.6,0.6,1,0.8,1.3C22.6,18,22.6,18.1,22.6,18.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7aba8f5a2c33a4f3d93ce18a0b8f932a.svg";
export { ForwardRef as ReactComponent };